<template>
  <li :class="{ 'load-cancelled': decorated.status_text === 'Cancelled' }">
    <router-link :to="{ name: 'loads.show', params: { id: load.id }}">
      <p class="load-reference">
        {{ decorated.reference_number }}
        <span class="load-status pull-right" :class="decorated.status_class">{{ decorated.status_text }}</span>
      </p>

      <p class="load-description">{{ decorated.commodity_and_location }}</p>

      <div class="row">
        <div class="col-xs-12"></div>
      </div>
    </router-link>

    <div class="row">
      <div class="col-xs-6 col-md-4 col-lg-2 col-xl-1">
        <p>
          <strong>Loading Date</strong><br />
          {{ decorated.loading_date}}
        </p>
      </div>
      <div class="col-xs-6 col-md-4 col-lg-2 col-xl-1">
        <p>
          <strong>Loading Time</strong><br />
          {{ decorated.loading_time }}
        </p>
      </div>
      <div class="col-xs-6 col-md-4 col-lg-2 col-xl-1">
        <p>
          <strong>Delivery Date</strong><br />
          {{ decorated.delivery_date }}
        </p>
      </div>
      <div class="col-xs-6 col-md-4 col-lg-2 col-xl-1">
        <p>
          <strong>Delivery Time</strong><br />
          {{ decorated.delivery_time }}
        </p>
      </div>
      <div class="col-xs-6 col-md-4 col-lg-2 col-xl-1">
        <p>
          <strong>Net Weight</strong><br />
          {{ decorated.net_weight }}
        </p>
      </div>
      <div class="col-xs-6 col-md-4 col-lg-2 col-xl-1">
        <p>
          <strong>Rate</strong><br />
          {{ decorated.rate }}
        </p>
      </div>
      <div class="col-xs-6 col-md-4 col-lg-2 col-xl-4">
        <p class="load-cost">
          <strong>Load Income</strong><br />

          {{ carrierProfitAsMoney }}
        </p>
      </div>
      <div class="col-xs-6 col-md-4 col-lg-2 col-xl-4">
        <p class="truncate">
          <strong>Carrier</strong><br />
          {{ decorated.company }}
        </p>
      </div>
      <div class="col-xs-6 col-md-4 col-lg-2 col-xl-1">
        <p>
          <strong>Rego</strong><br />
          {{ decorated.registration }}
        </p>
      </div>
      <div class="col-xs-6 col-md-4 col-lg-2 col-xl-1">
        <p>
          <strong>Configuration</strong><br />
          {{ decorated.configuration_description }}
        </p>
      </div>
      <div class="col-xs-6 col-md-4 col-lg-3 col-xl-2">
        <p>
          <strong>Weighbridge Details</strong><br />

          <a
            v-if="haveWeighbridge"
            @click="setActiveLoad"
            data-toggle="modal"
            data-target=".modal-load-check">
            View <i class="fa fa-external-link-square"></i>
          </a>
          <span v-else>&ndash;</span>
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12 col-sm-8 col-lg-6">
        <p class="material-details">
          <strong>Driver Notes</strong><br>
          {{ load.notes ? load.notes : '–' }}
        </p>
      </div>
      <div class="col-xs-6 col-md-4 col-lg-3">
        <p class="material-details">
          <strong>Dockets</strong><br>
          <span v-html="dockets ? dockets : '–'"></span>
        </p>
      </div>
      <div v-if="$user.isCarrier" class="col-xs-6 col-md-4 col-lg-3">
        <p class="material-details">
          <strong>Additional Charges</strong><br>
          <span>{{ additionalChargesTotalAsMoney }}</span>
        </p>
      </div>
    </div>
  </li>
</template>

<script>
  import { loadHelpers } from 'mixins/loads'

  export default {
    props: ['load'],

    mixins: [loadHelpers]
  }
</script>



// WEBPACK FOOTER //
// LoadItem.vue?77ee6253